import { apiService } from './enviroment';

export default apiService;
